import { component } from 'picoapp'
import gsap from 'gsap'

export default component((node, ctx) => {
  const setHeight = gsap.quickSetter(node, 'height', 'px')
  ctx.on('resize', ({ wh }) => setHeight(wh))
  return () => {}
})
